module.exports = __webpack_public_path__ + "static/media/VesselOwn2.a6dcad57.png";